import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["popup", "downloadButton"]

  connect() {
    App.initializeRadios()
  }

  closePopup() {
    var popup = this.popupTarget
    var downloadButton = this.downloadButtonTarget

    setTimeout(function () {
      downloadButton.disabled = false
      downloadButton.innerHTML = i18n.t("js.download")

      App.modal(popup, "hide")
    }, 3000)
  }
}
